import React from "react";
import {
  appointmentStatusLabel,
  appointmentStatusTone,
} from "./appointmentHelpers";

function AppointmentStatusBadge({ item, className = "" }) {
  if (!item) return null;
  const tone = appointmentStatusTone(item);
  const label = appointmentStatusLabel(item);

  return (
    <span
      className={`dd-appt-status dd-appt-status--${tone}${
        className ? ` ${className}` : ""
      }`}
    >
      {label}
    </span>
  );
}

export default AppointmentStatusBadge;
